import { action } from "typesafe-actions";
import { Student } from "../../interfaces";

export enum StudentRoomAssignmentActionTypes {
  ASSIGN_STUDENT_REQUEST = "@@studentRoomAssignment/ASSIGN_STUDENT_REQUEST",
  ASSIGN_STUDENT_SUCCESS = "@@studentRoomAssignment/ASSIGN_STUDENT_SUCCESS",
  ASSIGN_STUDENT_ERROR = "@@studentRoomAssignment/ASSIGN_STUDENT_ERROR",
  UNASSIGN_STUDENT_REQUEST = "@@studentRoomAssignment/UNASSIGN_STUDENT_REQUEST",
  UNASSIGN_STUDENT_SUCCESS = "@@studentRoomAssignment/UNASSIGN_STUDENT_SUCCESS",
  UNASSIGN_STUDENT_ERROR = "@@studentRoomAssignment/UNASSIGN_STUDENT_ERROR",
  GET_STUDENTS_IN_ROOM_REQUEST = "@@studentRoomAssignment/GET_STUDENTS_IN_ROOM_REQUEST",
  GET_STUDENTS_IN_ROOM_SUCCESS = "@@studentRoomAssignment/GET_STUDENTS_IN_ROOM_SUCCESS",
  GET_STUDENTS_IN_ROOM_ERROR = "@@studentRoomAssignment/GET_STUDENTS_IN_ROOM_ERROR",
  CLEAR_ASSIGNMENT_STATE = "@@studentRoomAssignment/CLEAR_ASSIGNMENT_STATE",
}

export interface AssignStudentPayload {
  student_id: string | number;
  room_id: string;
}

export interface UnassignStudentPayload {
  student_id: string | number;
}

export const assignStudentToRoom = (payload: AssignStudentPayload) => {
  return action(
    StudentRoomAssignmentActionTypes.ASSIGN_STUDENT_REQUEST,
    payload
  );
};

export const assignStudentToRoomSuccess = (student: Student) => {
  return action(
    StudentRoomAssignmentActionTypes.ASSIGN_STUDENT_SUCCESS,
    student
  );
};

export const assignStudentToRoomFailure = (error: any) => {
  return action(StudentRoomAssignmentActionTypes.ASSIGN_STUDENT_ERROR, error);
};

export const unassignStudentFromRoom = (payload: UnassignStudentPayload) => {
  return action(
    StudentRoomAssignmentActionTypes.UNASSIGN_STUDENT_REQUEST,
    payload
  );
};

export const unassignStudentFromRoomSuccess = (student: Student) => {
  return action(
    StudentRoomAssignmentActionTypes.UNASSIGN_STUDENT_SUCCESS,
    student
  );
};

export const unassignStudentFromRoomFailure = (error: any) => {
  return action(StudentRoomAssignmentActionTypes.UNASSIGN_STUDENT_ERROR, error);
};

export interface GetStudentsInRoomPayload {
  roomId: string;
  academicYear?: string;
}

export const getStudentsInRoom = (payload: GetStudentsInRoomPayload) => {
  return action(
    StudentRoomAssignmentActionTypes.GET_STUDENTS_IN_ROOM_REQUEST,
    payload
  );
};

export const getStudentsInRoomSuccess = (students: Student[]) => {
  return action(
    StudentRoomAssignmentActionTypes.GET_STUDENTS_IN_ROOM_SUCCESS,
    students
  );
};

export const getStudentsInRoomFailure = (error: any) => {
  return action(
    StudentRoomAssignmentActionTypes.GET_STUDENTS_IN_ROOM_ERROR,
    error
  );
};

export const clearAssignmentState = () => {
  return action(StudentRoomAssignmentActionTypes.CLEAR_ASSIGNMENT_STATE);
};
